export enum MaterialDiscountOption {
  DiscountOnSalePrice = 'DISCOUNT_ON_SALE_PRICE',
  MarginToPurchasePrice = 'MARGIN_TO_PURCHASE_PRICE',
}
